import { useSyncExternalStore } from "react";
import { liveSocket, type QuoteTick } from "@/lib/live";

/** Reads the live quote store directly — bypassing React Query per §21, since a per-second
 *  tick through the query cache would re-render the whole tree.
 *
 *  The returned tick carries `stale` (W4.1). Render it: a bid that stopped updating when the
 *  phone lost signal is not a price, and showing it as one is the specific lie §9 forbids. */
export function useQuote(symbol: string | null | undefined): QuoteTick | undefined {
  return useSyncExternalStore(
    (onChange) => (symbol ? liveSocket.subscribeQuote(symbol, onChange) : () => {}),
    () => (symbol ? liveSocket.getQuote(symbol) : undefined),
  );
}
